import { DirectiveOptions } from "vue/types/options";

import { deviceService } from "@/services";

export const envDirective: DirectiveOptions = {
  bind: (el: HTMLElement): void => {
    el.setAttribute("os", deviceService.getOs());
    el.setAttribute("os-type", deviceService.isSp() ? "sp" : "pc");
    el.setAttribute("browser", deviceService.getBrowser());
  },
};
